module.exports = __webpack_public_path__ + "static/media/gif.0e6ecd79.gif";